import { render, staticRenderFns } from "./weekly-calendar.vue?vue&type=template&id=0a5628dd&"
import script from "./weekly-calendar.vue?vue&type=script&lang=ts&"
export * from "./weekly-calendar.vue?vue&type=script&lang=ts&"
import style0 from "./weekly-calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports